import { useCallback, useMemo } from 'react';
import debounce from 'lodash/debounce';
export default function useDebounceCallback(handler, timeout) {
  const debouncedHandler = useMemo(() => handler && debounce(handler, timeout), [handler, timeout]);
  const memoizedHandler = useCallback((value, e) => {
    if (value) {
      debouncedHandler == null ? void 0 : debouncedHandler(value, e);
      return;
    }
    debouncedHandler == null ? void 0 : debouncedHandler.cancel();
    handler == null ? void 0 : handler(value, e);
  }, [handler, debouncedHandler]);
  if (!timeout) return handler;
  return memoizedHandler;
}